import { render, staticRenderFns } from "./drawing-details.vue?vue&type=template&id=5b3f7cb2"
import script from "./drawing-details.vue?vue&type=script&lang=js"
export * from "./drawing-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports